<template>
  <div id="app-login">

    <div class="logo">
      <img src="../assets/logo.png">
    </div>

    <div class="notice error" v-bind:class="notice">{{ message }}</div>

    <div class="form-field">
      <div class="form-label">
        <label>Username</label>
      </div>
      <div class="form-input">
        <div class="form-input-wrapper">
          <i class="icon icon-icon_users"></i>
          <input type="text" value="" v-model="credentials.email" v-on:keyup="onEnter"/>
        </div>
      </div>
    </div>

    <div class="form-field">
      <div class="form-label">
        <label>Mot de passe</label>
      </div>
      <div class="form-input">
        <div class="form-input-wrapper">
          <i class="icon icon-icon_lock"></i>
          <input type="password" value="" v-model="credentials.password" v-on:keyup="onEnter"/>
        </div>
      </div>
    </div>

    <footer>
      <button class="bt bt-primary" @click="submit()"><span>Login</span></button>
    </footer>
  </div>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                notice: "hidden",
                message: "erreur",
                credentials: {
                    email: '',
                    password: ''
                },
                error: ''
            }
        },
        mounted: function(){
            this.$store.dispatch("logout").then(() => {
                // LOG OUT
            })
        },
        methods: {
            onEnter: function(e) {
                if (e.keyCode === 13) {
                    this.submit()
                }
            },
            submit() {
                var credentials = {
                    email: this.credentials.email,
                    password: this.credentials.password
                }
                this.$store.dispatch("login", credentials).then(() => {
                    //console.log("client", this.$store.client)
                    if( this.$store.state.scope == null ){
                        this.$router.push("/switch")
                    }else{
                        this.$router.push("/dashboard")
                    }

                }).catch(e => {
                    //this.notice = "show"
                    //this.message = e.data.message
                    //alert(e)
                });
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Login.vue